// JavaScript Document: bewegunglesen script_form.js

$(document).ready(function() {

	// EVENTHANDLER (FUNKTIONSAUFRUF)
	//$("input.textInput").bind('click', function(){switchcontext("div.inputDescription"); });
	//$("input.textInput").bind('blur', function(){switchcontext("div.inputDescription"); });

	// EVENTHANDLER (FUNKTIONSAUFRUF)
	//$("input.textInput").bind('click', function(){switchcontext("div.inputDescription.red"); });
	//$("input.textInput").bind('blur', function(){switchcontext("div.inputDescription.red"); });

  // eventhandler for upload fields: essentials
  $("input.uploadEssentials").hover(
  function(){switchcontext("div.uploadEssentials"); },
  function(){switchcontext("div.uploadEssentials"); }
  );

  // eventhandler for upload fields: videothumbnail
    $("input.uploadVideoThumbnail").hover(
    function(){switchcontext("div.uploadVideoThumbnail"); },
    function(){switchcontext("div.uploadVideoThumbnail"); }
  );

  // eventhandler for upload fields: videoBeobachten
    $("input.uploadVideoBeobachten").hover(
  function(){switchcontext("div.uploadVideoBeobachten"); },
  function(){switchcontext("div.uploadVideoBeobachten"); }
  );

  // eventhandler for upload fields: videoBeurteilen
    $("input.uploadVideoBeurteilen").hover(
  function(){switchcontext("div.uploadVideoBeurteilen"); },
  function(){switchcontext("div.uploadVideoBeurteilen"); }
  );

  // eventhandler for upload fields: videoBeraten
    $("input.uploadVideoBeraten").hover(
  function(){switchcontext("div.uploadVideoBeraten"); },
  function(){switchcontext("div.uploadVideoBeraten"); }
  );

  // eventhandler for upload fields: videoForum
    $("input.uploadVideoForum").hover(
  function(){switchcontext("div.uploadVideoForum"); },
  function(){switchcontext("div.uploadVideoForum"); }
  );

  $('.answer-type.option1').hover(
      function(){switchcontext("div.answerOption1Tooltip"); },
      function(){switchcontext("div.answerOption1Tooltip"); }
  );
   $('.answer-type.option2').hover(
      function(){switchcontext("div.answerOption2Tooltip"); },
      function(){switchcontext("div.answerOption2Tooltip"); }
  );
   $('.answer-type.option3').hover(
      function(){switchcontext("div.answerOption3Tooltip"); },
      function(){switchcontext("div.answerOption3Tooltip"); }
  );

});

function switchcontext(eingabefeld){
	$(eingabefeld).fadeToggle("fast", "linear");
}